import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CommonService } from 'app/core/services/common.service';
import { RefreshConfigService } from 'app/core/services/refresh-config/refresh-config.service';

@Component({
  selector: 'dialog-delete-config',
  templateUrl: './dialog-delete-config.component.html',
  styleUrls: ['./dialog-delete-config.component.scss']
})
export class DialogDeleteConfigComponent implements OnInit {
  isLoading: boolean = false;

  constructor(public dialogRef: MatDialogRef<DialogDeleteConfigComponent>, @Inject(MAT_DIALOG_DATA) public data: any,
    private commonService: CommonService, private refreshConfigService: RefreshConfigService) { }

  ngOnInit(): void {
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  deleteConfig() {
    this.isLoading = true;
    this.commonService.deleteConfig(this.data.id).subscribe({
      next: (res) => {
        this.refreshConfigService.emitRefresh(this.data.index);
        this.isLoading = false;
        this.dialogRef.close();
      },
      error: (err) => {
        this.isLoading = true;
        console.error('Error deleting category:', err);
      },
    });
  }
}
